import styles from './ValidPasswordHelper.module.css';

const hasNumber = (str: string) => /\d/.test(str);

const hasLetter = (str: string) => /[a-zA-Z]/g.test(str);

const hasSpecialCharacter = (str: string) =>
  /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(str);

const CheckmarkSVG = () => (
  <svg
    className={styles.checkMarkSVG}
    focusable="false"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
  >
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
  </svg>
);

const XSVG = () => (
  <svg
    className={styles.xSVG}
    focusable="false"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
  >
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </svg>
);

export const isValidPassword = (str: string) => {
  return (
    str.length >= 8 &&
    hasLetter(str) &&
    hasNumber(str) &&
    hasSpecialCharacter(str)
  );
};

export const ValidPasswordHelper = ({ password }: { password: string }) => {
  if (!password) {
    return <div />;
  }

  const Rule = ({ text, isValid }: { text: string; isValid: boolean }) => (
    <div className={styles.passwordRule}>
      {isValid ? <CheckmarkSVG /> : <XSVG />}
      <p>{text}</p>
    </div>
  );
  return (
    <div>
      <Rule text="At least one letter" isValid={hasLetter(password)} />
      <Rule text="At least one number" isValid={hasNumber(password)} />
      <Rule text="Minimum eight characters" isValid={password.length >= 8} />
      <Rule
        text="At least one special character"
        isValid={hasSpecialCharacter(password)}
      />
    </div>
  );
};
